import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Template {
  id: string;
  watermarks?: unknown[];
  [key: string]: unknown;
}

interface TemplateState {
  templates: Template[];
}

const initialState: TemplateState = {
  templates: [],
};

export const templateSlice = createSlice({
  name: "templateSlice",
  initialState,
  reducers: {
    setTemplateBatch: (state, action: PayloadAction<Template>) => {
      const next = action.payload;
      const index = state.templates.findIndex((t) => t.id === next.id);
      if (index >= 0) {
        state.templates[index] = next;
      } else {
        state.templates = [...state.templates, next];
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setTemplateBatch } = templateSlice.actions;

export default templateSlice.reducer;
